/** Textos do modal de exclusão de serviço (lista de serviços). */

export const LISTA_SERVICOS_DELETE_MODAL = {
  title: 'Excluir serviço?',
  bodyIntro:
    'Esta ação não pode ser desfeita. Os lembretes vinculados a este serviço podem deixar de fazer sentido no histórico.',
  cancelLabel: 'Cancelar',
  confirmLabel: 'Excluir serviço',
  toastSuccess: 'Serviço excluído.',
  toastError: 'Não foi possível excluir o serviço.',
} as const;
